import type { ExamSummary, Participant, SessionInfo } from '../types'

const KEY = 'oap-exp1/session'

export interface StoredSession {
  token: string
  participant: Participant
  exam: ExamSummary
  session?: SessionInfo
  saved_at: string
}

export function loadSession(): StoredSession | null {
  if (typeof sessionStorage === 'undefined') return null
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<StoredSession>
    if (
      typeof parsed.token !== 'string' ||
      !parsed.participant ||
      typeof parsed.participant.id !== 'string' ||
      !parsed.exam ||
      typeof parsed.exam.id !== 'string'
    ) {
      return null
    }
    return parsed as StoredSession
  } catch {
    return null
  }
}

export function saveSession(session: StoredSession): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(session))
  } catch {
    // A blocked session store only costs a login after reload.
  }
}

export function clearSession(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // Ignore.
  }
}
